<template>
  <v-text-field
    v-model="valor"
    v-bind="properties"
    :label="label"
    :type="tipo"
    :placeholder="label"
    persistent-placeholder
    outlined
    dense
    @focus="desformatear()"
    @blur="formatear(1); $emit('blur')"
    @change="set_monto()"
    @keypress="enterKey"
  ></v-text-field>
</template>

<script>
import { format_money_round } from '../../util/utils'

export default {
  data () {
    return {
      valor: null,
      copia: null,
      tipo: 'tel'
    }
  },
  created () {
    this.formatear()
  },
  props: {
    value: Number,
    label: {
      type: String,
      default: ''
    },
    properties: {
      type: Object,
      default: function() {
        return {}
      }
    },
    precision:{
      type: Number,
      default: 2
    },
  },
  computed: {
    monto: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    monto () {
      this.formatear()
    }
  },
  methods: {
    enterKey (e) {
      if (e.key == 'Enter') document.activeElement.blur()
    },
    set_monto () {
      if (this.tipo == 'number') {
        const valor_numerico = parseFloat(JSON.parse(JSON.stringify(this.valor)))
        this.monto = Number.isNaN(valor_numerico) ? null : parseFloat(valor_numerico.toFixed(this.precision))
      }
    },
    desformatear () {
      this.tipo = 'number'
      const valor_numerico = parseFloat(this.valor.replaceAll('.', '').replace(',', '.').replace(' ', ''))
      this.valor = Number.isNaN(valor_numerico) ? null : parseFloat(valor_numerico.toFixed(this.precision))
      document.activeElement.click()
      this.copia = JSON.stringify(this.valor)
    },
    formatear (validar_change) {
      this.tipo = 'tel'
      this.valor = format_money_round(this.monto, this.precision).replace('$', '').trim()
      if (validar_change == 1 && format_money_round(JSON.parse(this.copia), this.precision).replace('$', '').trim() != this.valor) {
        this.$emit('change')
      }
    }
  }
}
</script>